import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  overflow-x: auto;
`;

export const ContainerBack = styled.div`
  display: grid;
  grid-template-columns: 27vw 1fr;
  background-color: white;
  width: 108%;
`;

export const ContentBack = styled.div`
  display: grid;
  grid-template-columns: 7vw 8.2vw 12vw 1fr;
  align-items: center;
  @media only screen and (min-width: 769px) {
    grid-template-columns: 7vw 8vw 1fr;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    grid-template-columns: 13vw 13vw 1fr;
  }
  @media only screen and (max-width: 480px) {
    grid-template-columns: 25vw 25vw 1fr;
  }
`;

export const ButtonBack = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 60%;
  height: 25px;
  margin: 0px auto;
  text-align: left;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ContentText = styled.div`
  display: flex;
  justify-content: space-between;
  width: 85vw;
`;

export const SpanForm = styled.span`
  width: 110px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 600;
`;

export const SpanCaseId = styled.span`
  color: ${({ theme }) => theme.primary.purple};
  font-weight: 600;
`;

export const SpanCreationDate = styled.span`
  font-weight: 600;
  font-size: 12px;
`;

export const Hr = styled.div`
  width: 108%;
  border: 1px solid
    ${({ theme, color }) => (color ? color : theme.secondaryGrayLightThree)};
`;
